<p-toast></p-toast>
<mat-sidenav-container autosize class="h-screen relative">
  <mat-sidenav #sidenav [mode]="isMobile ? 'over' : 'side'" opened="true" (opened)="events.push('open!')"
    (closed)="events.push('close!')" [fixedInViewport]="true"
    class="!overflow-visible !flex !flex-col !h-full !w-auto !bg-mirage-950 !text-white !max-w-[280px] !gap-6"
    [style.width.px]="isCollapsed ? 100 : 280">
    <div class="relative flex flex-col w-auto h-32 pt-6 pb-6 pr-4 pl-4 gap-3">
      @if (!isCollapsed) {
      <img ngSrc="asset/logo-sidebar.png" width="100" height="100" class="w-full" alt="login-logo">
      } @else {
      <img ngSrc="asset/logo-collapsabled.png" width="100" height="100" class="w-full" alt="login-logo-collapsabled">
      }
    </div>
    <button (click)="toggleSidenav()" class="cursor-pointer absolute right-[-18px] top-6 w-10 h-10 rounded-full
          bg-gray-900 shadow-lg border border-white/10 flex flex-col items-center justify-center
          hover:bg-gray-800">
      @if (isCollapsed) {
      <i class="fi-rr-angle-small-right flex items-center justify-center text-white text-xl"></i>
      } @else {
      <i class="fi-rr-angle-small-left flex items-center justify-center text-white text-xl"></i>
      }
    </button>
    @if (accountService.hasAnyAuthority(ROLE_BUYER) || accountService.hasAnyAuthority(ROLE_OWNER)) {
    <mat-nav-list>
      <div class="p-6">
        <a [routerLink]="['/home/pedidos']" #rla="routerLinkActive" routerLinkActive
          class="flex items-center p-4 rounded-3xl group gap-3 justify-start"
          [ngClass]="{'bg-solitude-100 text-white': rla.isActive, 'hover:bg-solitude-100': !rla.isActive,}">
          <span class="flex items-center gap-3">
            <i class="fi-rr-apps-add text-2xl flex w-5 h-5 transition duration-75"
              [ngClass]="{'text-orange-500': rla.isActive, 'text-gray-chateau-400 group-hover:text-orange-500': !rla.isActive}">
            </i>
            @if (!isCollapsed) {
            <span class="ms-1 text-gray-chateau-400 group-hover:text-white text-base"
              [ngClass]="{'text-white': rla.isActive, 'text-gray-chateau-400 group-hover:text-white': !rla.isActive}">
              Pedidos
            </span>
            }
          </span>
        </a>
      </div>
    </mat-nav-list>
    }
    @if (accountService.hasAnyAuthority("ADMIN")) {
    <mat-nav-list class="border-t-2 border-slate-200/10">
      <div class="p-6">
        <a [routerLink]="['/home/comprador']" #rla="routerLinkActive" routerLinkActive
          class="flex items-center p-4 rounded-3xl group gap-3 justify-start"
          [ngClass]="{'bg-solitude-100 text-white': rla.isActive, 'hover:bg-solitude-100': !rla.isActive,}">
          <i class="fi-rr-user-helmet-safety text-2xl flex w-5 h-5 transition duration-75"
            [ngClass]="{'text-orange-500': rla.isActive, 'text-gray-chateau-400 group-hover:text-orange-500': !rla.isActive}">
          </i>
          @if (!isCollapsed) {
          <span class="ms-1 text-gray-chateau-400 group-hover:text-white text-base"
            [ngClass]="{'text-white': rla.isActive, 'text-gray-chateau-400 group-hover:text-white': !rla.isActive}">
            Externos
          </span>
          }
        </a>
        <a [routerLink]="['/home/interno']" #rlaIntern="routerLinkActive" routerLinkActive
          class="flex items-center p-4 rounded-3xl group gap-3 justify-start"
          [ngClass]="{'bg-solitude-100 text-white': rlaIntern.isActive, 'hover:bg-solitude-100': !rlaIntern.isActive,}">
          <i class="fi-rr-user-gear text-2xl flex w-5 h-5 transition duration-75"
            [ngClass]="{'text-orange-500': rlaIntern.isActive, 'text-gray-chateau-400 group-hover:text-orange-500': !rlaIntern.isActive}">
          </i>
          @if (!isCollapsed) {
          <span class="ms-1 text-gray-chateau-400 group-hover:text-white text-base"
            [ngClass]="{'text-white': rlaIntern.isActive, 'text-gray-chateau-400 group-hover:text-white': !rlaIntern.isActive}">
            Internos
          </span>
          }
        </a>
      </div>
    </mat-nav-list>
    }
    @if (accountService.hasAnyAuthority(ROLE_MANAGER)) {
    <mat-nav-list class="border-t-2 border-slate-200/10">
      <div class="p-6">

        <!-- Ventas -->
        <a [routerLink]="['/home/ventas']" #rlaVentas="routerLinkActive" routerLinkActive [routerLinkActiveOptions]="{ exact: true }"
           class="flex items-center p-4 rounded-3xl group gap-3 justify-start"
           [ngClass]="{'bg-solitude-100 text-white': rlaVentas.isActive, 'hover:bg-solitude-100': !rlaVentas.isActive}">

          <i class="fi-rr-shopping-cart text-2xl flex w-5 h-5 transition duration-75"
             [ngClass]="{'text-orange-500': rlaVentas.isActive, 'text-gray-chateau-400 group-hover:text-orange-500': !rlaVentas.isActive}">
          </i>

          @if (!isCollapsed) {
            <span class="ms-1 text-gray-chateau-400 group-hover:text-white text-base"
                  [ngClass]="{'text-white': rlaVentas.isActive, 'text-gray-chateau-400 group-hover:text-white': !rlaVentas.isActive}">
        Ventas
      </span>
          }

        </a>

        <!-- Reporte de ventas -->
        <a [routerLink]="['/home/ventas/reporte']" #rlaReporteVentas="routerLinkActive" routerLinkActive [routerLinkActiveOptions]="{ exact: true }"
           class="flex items-center p-4 rounded-3xl group gap-3 justify-start"
           [ngClass]="{'bg-solitude-100 text-white': rlaReporteVentas.isActive, 'hover:bg-solitude-100': !rlaReporteVentas.isActive}">

          <i class="fi-rr-stats text-2xl flex w-5 h-5 transition duration-75"
             [ngClass]="{'text-orange-500': rlaReporteVentas.isActive, 'text-gray-chateau-400 group-hover:text-orange-500': !rlaReporteVentas.isActive}">
          </i>

          @if (!isCollapsed) {
            <span class="ms-1 text-gray-chateau-400 group-hover:text-white text-base"
                  [ngClass]="{'text-white': rlaReporteVentas.isActive, 'text-gray-chateau-400 group-hover:text-white': !rlaReporteVentas.isActive}">
      Reporte de ventas
    </span>
          }

        </a>

      </div>
    </mat-nav-list>
    <mat-nav-list class="border-t-2 border-slate-200/10">
      <div class="p-6">
        <a [routerLink]="['/home/producto']" #rla="routerLinkActive" routerLinkActive
          class="flex items-center p-4 rounded-3xl group gap-3 justify-start"
          [ngClass]="{'bg-solitude-100 text-white': rla.isActive, 'hover:bg-solitude-100': !rla.isActive,}">
          <i class="fi-rr-boxes text-2xl flex w-5 h-5 transition duration-75"
            [ngClass]="{'text-orange-500': rla.isActive, 'text-gray-chateau-400 group-hover:text-orange-500': !rla.isActive}">
          </i>
          @if (!isCollapsed) {
          <span class="ms-1 text-gray-chateau-400 group-hover:text-white text-base"
            [ngClass]="{'text-white': rla.isActive, 'text-gray-chateau-400 group-hover:text-white': !rla.isActive}">
            Productos
          </span>
          }
        </a>
        <a [routerLink]="['/home/item']" #rlaItem="routerLinkActive" routerLinkActive
          class="flex items-center p-4 rounded-3xl group gap-3 justify-start"
          [ngClass]="{'bg-solitude-100 text-white': rlaItem.isActive, 'hover:bg-solitude-100': !rlaItem.isActive,}">
          <i class="fi-rr-box-open-full text-2xl flex w-5 h-5 transition duration-75"
            [ngClass]="{'text-orange-500': rlaItem.isActive, 'text-gray-chateau-400 group-hover:text-orange-500': !rlaItem.isActive}">
          </i>
          @if (!isCollapsed) {
          <span class="ms-1 text-gray-chateau-400 group-hover:text-white text-base"
            [ngClass]="{'text-white': rlaItem.isActive, 'text-gray-chateau-400 group-hover:text-white': !rlaItem.isActive}">
            Ítems
          </span>
          }
        </a>
        <a [routerLink]="['/home/color']" #rlaColor="routerLinkActive" routerLinkActive
          class="flex items-center p-4 rounded-3xl group gap-3 justify-start"
          [ngClass]="{'bg-solitude-100 text-white': rlaColor.isActive, 'hover:bg-solitude-100': !rlaColor.isActive,}">
          <i class="fi-rr-palette text-2xl flex w-5 h-5 transition duration-75"
            [ngClass]="{'text-orange-500': rlaColor.isActive, 'text-gray-chateau-400 group-hover:text-orange-500': !rlaColor.isActive}">
          </i>
          @if (!isCollapsed) {
          <span class="ms-1 text-gray-chateau-400 group-hover:text-white text-base"
            [ngClass]="{'text-white': rlaColor.isActive, 'text-gray-chateau-400 group-hover:text-white': !rlaColor.isActive}">
            Diseños
          </span>
          }
        </a>
      </div>
    </mat-nav-list>
    }
    <mat-toolbar
      class="bottom-toolbar absolute bottom-0 left-0 right-0 !bg-mirage-950 !text-white border-t border-slate-200/10">
      @if (accountService.hasAnyAuthority([ROLE_BUYER, ROLE_OWNER])) {
      <a [routerLink]="['/home/perfil']" #rla="routerLinkActive" routerLinkActive
        class="toolbar-item flex items-center px-4 py-3 group gap-3 justify-start"
        [ngClass]="{'bg-solitude-100 text-white': rla.isActive, 'hover:bg-solitude-100': !rla.isActive,}">
        <i class="fi fi-rr-info text-2xl flex w-5 h-5 transition duration-75"
          [ngClass]="{'text-orange-500': rla.isActive, 'text-gray-chateau-400 group-hover:text-orange-500': !rla.isActive}">
        </i>
        @if (!isCollapsed) {
        <span class="ms-1 text-gray-chateau-400 group-hover:text-white text-base"
          [ngClass]="{'text-white': rla.isActive, 'text-gray-chateau-400 group-hover:text-white': !rla.isActive}">
          Información de la cuenta
        </span>
        }
      </a>
      }

      <div (click)="accountService.logout()"
        class="toolbar-item flex px-4 py-3 items-center justify-start group cursor-pointer">
        <fa-icon (click)="accountService.logout()" [icon]="faRightFromBracket"
          class="text-gray-chateau-400 group-hover:text-orange-500 cursor-pointer"></fa-icon>
        <button (click)="accountService.logout()"
          class="text-gray-chateau-400 group-hover:text-white font-medium transition cursor-pointer text-base">
          @if (!isCollapsed) {
          <span class="ms-2 text-gray-chateau-400 dark:text-gray-chateau-400 group-hover:text-white">Cerrar
            sesión</span>
          }
        </button>
      </div>
    </mat-toolbar>
  </mat-sidenav>

  <mat-sidenav #rightSidenav position="end" [mode]="isMobile ? 'over' : 'side'" [opened]="showCart"
    [fixedInViewport]="true" [style.width.px]=400
    class="!border-1 !border-white !rounded-3xl !shadow-[0px_16px_44px_0px_#00000012]">
    <app-product-cart-component></app-product-cart-component>
  </mat-sidenav>

  <mat-sidenav-content class="flex flex-col p-5 gap-5 bg-mirage-50 min-h-0">
    <div [ngClass]="{'flex justify-between': isMobile}">
      @if (isMobile) {
      <div>
        <button (click)="sidenav.open()" class="p-1.5 sm:p-2 rounded-full hover:bg-slate-200/10 transition">
          <i class="fi-rr-menu-burger text-black text-xl transition-transform duration-300"
            [ngClass]="{ 'rotate-180': isCollapsed }"></i>
        </button>
      </div>
      }
      <div class="flex mr-2 sm:mr-4 gap-2 sm:gap-3 mb-4 sm:mb-6 items-center"
        [ngClass]="{'justify-between': showBreadcrumbDiv, 'justify-end': !showBreadcrumbDiv}">
        @if (showBreadcrumbDiv) {
        <div>
          <p-breadcrumb [model]="items" [style]="{'background-color': '#f0f7fe'}">
            <ng-template #item let-item>
              <a class="cursor-pointer" [routerLink]="item.url">
                <span [ngClass]="{'text-orange-500': isActive(item)}">{{ item.label }}</span>
              </a>
            </ng-template>
          </p-breadcrumb>
        </div>
        }
        <div class="flex flex-row items-center gap-3 sm:gap-4">
          <fa-icon [icon]="faUserCircle" size="2xl" class="text-gray-chateau-300"></fa-icon>
          <div class="flex flex-col">
            <span class="text-gray-chateau-400 text-xs sm:text-sm">Bienvenido</span>
            <span class="text-sm sm:text-base font-semibold">{{ user()?.user?.name ?? '--' }}</span>
            @if (activeWarehouse()) {
              <span class="text-xs text-orange-500 font-medium">
                <i class="fi-rr-warehouse text-xs"></i>
                {{ activeWarehouse()?.name }}
              </span>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-5 flex-1 min-h-0">
      <router-outlet></router-outlet>
    </div>
    <div class="flex justify-end">
      <span class="text-[10px] tracking-[0.4em] uppercase text-gray-400">
        {{ versionLabel$ | async }}
      </span>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
